import { useTranslation } from "react-i18next";
interface AuthHeaderProps {
  authMethod: "password" | "otp" | "register";
}
export const AuthHeader = ({
  authMethod
}: AuthHeaderProps) => {
  const {
    t
  } = useTranslation();
  return <div className="text-center">
      
      <h2 className="font-bold text-xl">
        {authMethod === "otp" ? t("auth.loginWithEmail") : authMethod === "register" ? t("auth.createAccount") : t("auth.welcomeBack")}
      </h2>
      <p className="text-travel-500 mt-2">
        {authMethod === "otp" ? t("auth.enterEmailForCode") : authMethod === "register" ? t("auth.signUpToManageTrips") : t("auth.signInToAccessTrips")}
      </p>
    </div>;
};